import { render, staticRenderFns } from "./Bioanalysts.vue?vue&type=template&id=1297d63c"
import script from "./Bioanalysts.vue?vue&type=script&lang=js"
export * from "./Bioanalysts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports